export function scrollAndLoadHelper(
  offset,
  currentList,
  payload,
  payloadMapper,
) {
  // Handled uninitialized cases
  const newList = currentList && currentList.slice ? currentList.slice() : [];
  const endIndex = payload.count + offset;
  const payLoadData = payload.data.slice();
  for (let i = offset; i < endIndex; i += 1) {
    const payloadDatum = payLoadData.shift();
    newList[i] = payloadMapper ? payloadMapper(payloadDatum) : payloadDatum;
  }
  return newList;
}

export default scrollAndLoadHelper;
